// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"Logout_modal_title__1zMD5","buttons_wrapper":"Logout_buttons_wrapper__3aa25"};